import { BIOME_IDS, BIOMES } from '../data/biomes.js';
import { BOUNTIES_PER_BOARD, bountiesOfBiome } from '../data/bounties.js';
import { DAILY_CONTRACT_GOLD } from '../data/contracts.js';
import { UPGRADE_MATERIALS } from '../data/upgrade-materials.js';
import { seedOf } from './contracts.js';
import { seededRng } from './random.js';
/**
 * The wanted boards (ADR 0096), pure. Each board's bounties of a game day
 * are drawn from a seed of the character, the day and the board's region,
 * then written down once with the kills they are measured against, like
 * the contracts (ADR 0051): a bounty is done once the career holds one
 * more kill of its target than when it was drawn.
 */
/** The row the day's bounties are written in, beside the contracts (`character_contracts`). */
export function bountyPeriod(day) {
    return `B${day}`;
}
/** Half a daily contract of the region: a single fight, not ten minutes of hunting. */
export function bountyGold(biome) {
    return Math.round(DAILY_CONTRACT_GOLD[biome] / 2);
}
export function bountyItems(biome) {
    return [{ templateId: UPGRADE_MATERIALS[biome].common.id, quantity: 1 }];
}
/** One board's bounties for a character on a game day: never the same target twice. */
export function drawBoardBounties(characterId, day, biome) {
    const rng = seededRng(seedOf(`${characterId}:${day}:bounty:${biome}`));
    const pool = bountiesOfBiome(biome);
    const bounties = [];
    for (let index = 0; index < BOUNTIES_PER_BOARD && pool.length > 0; index += 1) {
        const [mob] = pool.splice(Math.floor(rng() * pool.length), 1);
        if (mob === undefined)
            break;
        bounties.push({
            slot: `${biome}-${String(index)}`,
            mob,
            biome,
            reward: { gold: bountyGold(biome), items: bountyItems(biome) },
        });
    }
    return bounties;
}
/** Every board's bounties of the day, written down together the first time one is read. */
export function drawBounties(characterId, day) {
    return BIOME_IDS.flatMap((biome) => drawBoardBounties(characterId, day, biome));
}
/** What a bounty is measured against: the kills of its target, as they stand. */
export function bountyCounters(bounty, career) {
    return { [bounty.mob]: career.kills[bounty.mob] ?? 0 };
}
/** Slain since it was drawn: by its taker, or by their party at their side. */
export function bountyDone(bounty, baseline, career) {
    return (career.kills[bounty.mob] ?? 0) > (baseline[bounty.mob] ?? 0);
}
/** Under the region's band, its board's targets are out of reach: they stay on the board. */
export function bountyLevelRefused(level, biome) {
    return level < BIOMES[biome].level.min;
}
//# sourceMappingURL=bounties.js.map